import { EcosystemServiceModel } from "@shared/models/ecosystem-service.model";

export const _08_WATER_AS_MATERIAL:Partial<EcosystemServiceModel> ={
  id:'water-as-material',
  pos:8,
  image: "/images/ecoservices/water_as_material.jpg",
  code: ["4.2.1.2","4.2.2.2"],
  unit:'water as material',
  assetType:'other',
  serviceType: 'provisioning',
  valuationMethods:[
    {
      id: 'market',
      name:"Market prices",
      unit: "m3",
      element: "water as material",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    }
  ]

}
